import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'kbSearch',
  version: '1.0.0',
  properties: [
    // ==================================================================
    // COLLECTION CONFIGURATION
    // ==================================================================
    {
      key: 'collectionId',
      label: 'Collection',
      type: 'options',
      required: true,
      default: '',
      options: [],
      optionsSource: 'knowledgeBaseCollections',
      description: 'The knowledge base collection to search',
      placeholder: 'Select a collection...',
    },

    // ==================================================================
    // SEARCH CONFIGURATION
    // ==================================================================
    {
      key: 'query',
      label: 'Search Query',
      type: 'string',
      required: true,
      default: '',
      placeholder: 'e.g., {{ $json.question }} or "What is..."',
      description: 'The search query. Supports expressions like {{ $json.query }}',
      fromAI: {
        enabled: true,
        description: 'The search query to find relevant documents in the knowledge base',
      },
    },
    {
      key: 'topK',
      label: 'Number of Results',
      type: 'number',
      required: false,
      default: 5,
      typeOptions: {
        minValue: 1,
        maxValue: 50,
      },
      description: 'Maximum number of results to return',
    },
    {
      key: 'minScore',
      label: 'Minimum Score',
      type: 'number',
      required: false,
      default: 0.7,
      typeOptions: {
        minValue: 0,
        maxValue: 1,
        numberStepSize: 0.05,
      },
      description: 'Minimum similarity score threshold (0-1)',
    },

    // ==================================================================
    // OUTPUT CONFIGURATION
    // ==================================================================
    {
      key: 'includeContent',
      label: 'Include Content',
      type: 'boolean',
      required: false,
      default: true,
      description: 'Include full document content in results',
    },
    {
      key: 'outputFormat',
      label: 'Output Format',
      type: 'options',
      required: false,
      default: 'full',
      options: [
        { value: 'full', name: 'Full (results with metadata)' },
        { value: 'context', name: 'Context (concatenated text)' },
        { value: 'documents', name: 'Documents (simplified list)' },
      ],
      description: 'How to format the search results',
    },

  ],
};

export default schema;
